import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Button, Icon } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import eventSurveysActionCreators from "~/store/eventSurveys/actions";
import eventSurveySelectors from "~/store/eventSurveys/selectors";
import { StatusStateEnum } from "~/types/enums";
import EventSurveyStringQuestionForm from "~/forms/EventSurveyStringQuestionForm";
import eventSurveyStringQuestionSchema from "~/forms/EventSurveyStringQuestionForm/eventSurveyStringQuestionSchema";
import styled from "styled-components";
const Form = styled.form`
  width: 100%;
`;
const EventSurveyStringQuestion = _ref => {
  let {
    surveyId,
    questionId,
    active,
    answer,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const status = useSelector(eventSurveySelectors.getAnswerStatus(questionId));
  const {
    handleSubmit,
    control
  } = useForm({
    resolver: yupResolver(eventSurveyStringQuestionSchema),
    defaultValues: {
      value: answer || ""
    }
  });
  const onSubmit = handleSubmit(data => {
    dispatch(eventSurveysActionCreators.answerStarted(surveyId, questionId, data.value));
  });
  return /*#__PURE__*/React.createElement(Form, _extends({
    onSubmit: onSubmit
  }, rest), /*#__PURE__*/React.createElement(EventSurveyStringQuestionForm, {
    control: control,
    active: active
  }), answer ? /*#__PURE__*/React.createElement(Button, {
    color: "success",
    s: {
      px: 5,
      py: 1,
      mt: 3
    },
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "tick",
    s: {
      mr: 2
    }
  }), t("common.actions.answered")) : /*#__PURE__*/React.createElement(Button, {
    rounded: true,
    s: {
      px: 5,
      py: 1,
      mt: 3
    },
    onClick: onSubmit,
    disabled: !active,
    loading: status === StatusStateEnum.LOADING
  }, t("common.actions.send")));
};
export default EventSurveyStringQuestion;